<template>
  <div class="px-4">
    <GalleryHeader />
    <GalleryCarousel class="!pt-10" />
    <hr />
    <GalleryFull />
  </div>
</template>

<script setup lang="ts">
useHead({
	title: "Circus St. Ottilien • Galerie",
});
</script>
